const STATES = {
    NSW: 'NSW',
    QLD: 'QLD',
    SA: 'SA',
    TAS: 'TAS',
    VIC: 'VIC',
    WA: 'WA',
    ACT: 'ACT',
    NT: 'NT'
};

export default STATES;
